// extracted by mini-css-extract-plugin
module.exports = {"container":"clinical-portal-3__DropdownLinkTitle__container","description":"clinical-portal-3__DropdownLinkTitle__description"};